// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_tp-0";